import { FC } from 'react';
import StudentSimpleList from './StudentSimpleList';
import UseStudentSimpleList from './UseStudentSimpleList';

const StudentSimpleListContainer: FC = () => {
  return <StudentSimpleList {...UseStudentSimpleList()} />;
};

export default StudentSimpleListContainer;
